import SpinwheelBillsReview from '../../../../onboarding/components/billReview/SpinwheelBillsReview';

export default function SpinwheelBillsReviewScreen() {
    return <SpinwheelBillsReview />;
}
